import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { ArrowIconWrapper, MenuButtonWrapper } from 'src/components/Menu/Menu.style';
import { MenuItemsNavigationTrading } from 'src/layouts/TradingPage/TradingMenuItems.style';

type CustomerRouteType =
    | 'events'
    | 'liabilities'
    | 'tags'
    | 'bet-search'
    | 'payment-search'
    | 'csv-upload'
    | 'automation';

export const TradingMenuItems = observer((): JSX.Element | null => {
    const { routerBackoffice, appEnvParams } = useAppStateContext();
    const customerParams = routerBackoffice.getParametersString('global', 'tab') ?? 'events';

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    interface MenuItemsType {
        id: CustomerRouteType;
        label: string;
        onClick: () => void;
    }

    const menuItems: Array<MenuItemsType> = [
        {
            id: 'events',
            label: 'Events',
            onClick: (): void => routerBackoffice.redirectToTradingEvents(),
        },
        {
            id: 'liabilities',
            label: 'Liabilities',
            onClick: (): void => routerBackoffice.redirectToTradingLiabilities(),
        },
        {
            id: 'tags',
            label: 'Tag management',
            onClick: (): void => routerBackoffice.redirectToTradingTags(),
        },
        {
            id: 'bet-search',
            label: 'Bet search',
            onClick: (): void => routerBackoffice.redirectToTradingBetSearch(),
        },
        {
            id: 'payment-search',
            label: 'Payment search',
            onClick: (): void => routerBackoffice.redirectToTradingPaymentSearch(),
        },
        {
            id: 'csv-upload',
            label: 'CSV upload',
            onClick: (): void => routerBackoffice.redirectToTradingCsvUpload(),
        },
        {
            id: 'automation',
            label: 'Automation',
            onClick: (): void => routerBackoffice.redirectToTradingAutomation(),
        },
    ];

    return (
        <MenuItemsNavigationTrading>
            {menuItems.map((linkItem) => {
                if (linkItem.id === 'automation' && appEnvParams.isGatewayActive === false) {
                    return null;
                }
                return (
                    <MenuButtonWrapper
                        key={linkItem.id}
                        isActive={isTabActive(linkItem.id)}
                        onClick={linkItem.onClick}
                    >
                        {linkItem.label}
                        <ArrowIconWrapper
                            isActive={isTabActive(linkItem.id)}
                            position='right'
                        />
                    </MenuButtonWrapper>
                );
            })}
        </MenuItemsNavigationTrading>
    );
});
